import qs from 'qs';
import client from './client';

export default {
  async getCoachList(params) {
    const response = await client.get(
      `account/coaches/${qs.stringify(params, { addQueryPrefix: true })}`,
    );
    return response.data;
  },

  async getById(id) {
    const response = await client.get(`account/mam/coach/${id}/`);
    return response.data;
  },

  async getByUrlIndex(url) {
    const response = await client.get(`account/profile/${url}/`);
    return response.data;
  },

  async getDraftByCoachId(id) {
    const response = await client.get(`account/mam/coach/${id}/`);
    return response.data;
  },

  async getDraftCoachProfile() {
    const response = await client.get('account/profile/');
    return response.data;
  },

  async getCoachCountries() {
    const response = await client.get('account/coaches/location/countries/');
    return response.data;
  },

  async getCoachRegions(country) {
    const response = await client.get(`account/coaches/location/country/${country}/regions`);
    return response.data;
  },

  async getCoachCities(region) {
    const response = await client.get(`account/coaches/location/region/${region}/cities/`);
    return response.data;
  },
};
